export default __webpack_public_path__ + "static/media/hover.4b10a769.jpg";